import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

export function useCallNumbers() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: callsKeys.numbers(locationId),
    queryFn: () => callsApi.listNumbers(locationId),
    enabled: !!locationId,
  });

  return { ...query, numbers: query.data ?? [], locationId };
}
